import MPopper from './index.vue';

export {
    MPopper,
};

export default MPopper;
